const leg = require('./leg_prototype');

function confirmationLeg(legData) {
    const confirmationLeg = Object.create(leg(legData));

    confirmationLeg._legPath = '';
    confirmationLeg._originPath = 'departureLocation';
    confirmationLeg._destinationPath = 'arrivalLocation';

    confirmationLeg.getDestinationAirportIata = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.iata`, '');
    };

    confirmationLeg.getOriginAirpotIata = function() {
        return Odigeo._.get(legData, `${this._originPath}.iata`, '');
    };

    confirmationLeg.getOriginCityName = function() {
        return Odigeo._.get(legData, `${this._originPath}.city`, '');
    };

    confirmationLeg.getCityName = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.city`, '');
    };

    confirmationLeg.getFlightNumber = function() {
        const carrierCode = Odigeo._.get(legData, `${this._legPath}.carrier.code`, '');
        const flightId = Odigeo._.get(legData, `${this._legPath}.flightNumber`, 0);

        return `${carrierCode}${flightId}`;
    };

    confirmationLeg.getOriginCountryName = function() {
        return Odigeo._.get(legData, `${this._originPath}.country`, '');
    };

    confirmationLeg.getDestinationCountryName = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.country`, '');
    };

    confirmationLeg.getOriginName = function() {
        return Odigeo._.get(legData, `${this._originPath}.airport`, '');
    };

    confirmationLeg.getDestinationName = function() {
        return Odigeo._.get(legData, `${this._destinationPath}.airport`, '');
    };

    return confirmationLeg;
}

module.exports = confirmationLeg;
